import TranslateUtils from '../../i18n/TranslateUtils'

import {useSignal, useSignals} from '@preact/signals-react/runtime'
import {useEffect, useRef} from 'react'
import {ReactComponent as MdSick} from '../../assets/icons/MdSick.svg'
import {ReactComponent as AssignHCP} from '../../assets/menu/AssignHCP.svg'
import {ReactComponent as AssignStaticList} from '../../assets/menu/AssignStaticList.svg'
import {showNotification} from '../notification/NotificationService'
import {isArrayAndNotEmpty} from '../observations/Utils'
import {permissionOptionKeys} from '../role/RoleConstant'
import {
    getTableRowSelectionEventKey,
    removeTableRowSelectionChangeListener,
    tableRowSelectionEvent,
    tableRowSelectionEventTypes,
} from './broadcast/RowEvent'
import {
    onItemTableToolBarSelectedListener,
    tableToolBarEventTypes,
} from './broadcast/TableToolBarEvent'
import {tableToolBarDescriptionList} from './Constant'
import {useDatatableContext} from './DataTableContext'
import StyledAssignmentHealthCarePractitioner from './StyledAssignmentHealthCarePractitioner'
import StyledAssignmentPathway from './StyledAssignmentPathway'
import StyledAssignmentStaticList from './StyledAssignmentStaticList'
import StyledToolbarIcon from './StyledToolbarIcon'

const StyledAssignmentToolBar = () => {
    useSignals()

    const {translateDatatable} = TranslateUtils()

    const {dataKey, tableType, handleCheckPermissionByKey} =
        useDatatableContext()

    const staticListAssignmentRef = useRef(null)
    const pathwayAssignmentRef = useRef(null)
    const hcpAssignmentRef = useRef(null)

    const disabled = useSignal(true)
    const selectedRowIds = useSignal([])

    const handleOnDisabledClick = () => {
        showNotification(
            'error',
            'Please select at least one patient from the table view',
        )
    }

    const handleOnRowSelectionChange = (newTableRowSelection = []) => {
        if (
            !newTableRowSelection ||
            !isArrayAndNotEmpty(newTableRowSelection)
        ) {
            disabled.value = true

            selectedRowIds.value = []
        } else {
            disabled.value = false

            selectedRowIds.value = newTableRowSelection.map(row => row[dataKey])
        }
    }

    useEffect(() => {
        tableRowSelectionEvent.on(
            `${getTableRowSelectionEventKey(
                tableType,
                tableRowSelectionEventTypes.ROW_SELECTION_CHANGE,
            )}`,
            newTableRowSelection => {
                console.log('here')
                handleOnRowSelectionChange(newTableRowSelection)
            },
        )

        return () => {
            removeTableRowSelectionChangeListener(
                tableType,
                tableRowSelectionEventTypes.ROW_SELECTION_CHANGE,
            )
        }
    })

    return (
        handleCheckPermissionByKey(
            permissionOptionKeys.allowToAssignStaticList,
        ) &&
        handleCheckPermissionByKey(permissionOptionKeys.allowToAssignPathway) &&
        handleCheckPermissionByKey(permissionOptionKeys.allowToAssignHcp) && (
            <div className="container">
                <div className="flex align-items-center justify-content-between px-2 mb-0">
                    <h6 className="toggle-group-label  font-bold m-0 mb-1 ">
                        {translateDatatable('Assignment')}
                    </h6>
                    <div className="cursor-pointer text-gray-600">
                        <i
                            className={`pi ${
                                disabled.value ? 'pi-lock' : 'pi-lock-open'
                            }`}></i>
                    </div>
                </div>

                <div className="custom-toolbar-items-wrapper py-0 pr-2">
                    {handleCheckPermissionByKey(
                        permissionOptionKeys.allowToAssignStaticList,
                    ) && (
                        <StyledToolbarIcon
                            id="assign-static-list"
                            icon={<AssignStaticList />}
                            label={translateDatatable('Static List')} //Assign to
                            disable={disabled.value}
                            description={
                                tableToolBarDescriptionList.assignToStaticList
                            }
                            onClick={() => {
                                staticListAssignmentRef.current.showForm()

                                onItemTableToolBarSelectedListener(
                                    tableType,
                                    tableToolBarEventTypes.ON_ITEM_SELECTED,
                                    'Static List',
                                )
                            }}
                            onDisabledClick={handleOnDisabledClick}
                        />
                    )}
                    {handleCheckPermissionByKey(
                        permissionOptionKeys.allowToAssignPathway,
                    ) && (
                        <StyledToolbarIcon
                            id="assign-pathway"
                            icon={<MdSick />}
                            label={translateDatatable('Pathway')}
                            disable={disabled.value}
                            description={
                                tableToolBarDescriptionList.assignToPathway
                            }
                            onClick={() => {
                                pathwayAssignmentRef.current.showForm()

                                onItemTableToolBarSelectedListener(
                                    tableType,
                                    tableToolBarEventTypes.ON_ITEM_SELECTED,
                                    'Pathway',
                                )
                            }}
                            onDisabledClick={handleOnDisabledClick}
                        />
                    )}
                    {handleCheckPermissionByKey(
                        permissionOptionKeys.allowToAssignHcp,
                    ) && (
                        <StyledToolbarIcon
                            id="assign-hcp"
                            icon={<AssignHCP />}
                            label={translateDatatable('HC.Practitioner')}
                            description={
                                tableToolBarDescriptionList.assignToHCP
                            }
                            disable={disabled.value}
                            onClick={() => {
                                hcpAssignmentRef.current.showForm()

                                onItemTableToolBarSelectedListener(
                                    tableType,
                                    tableToolBarEventTypes.ON_ITEM_SELECTED,
                                    'HC.Practitioner',
                                )
                            }}
                            onDisabledClick={handleOnDisabledClick}
                        />
                    )}
                </div>
                <hr className="toggle-toolbar-divider" />
                <StyledAssignmentStaticList
                    ref={staticListAssignmentRef}
                    userIds={selectedRowIds.value}
                />
                <StyledAssignmentPathway
                    ref={pathwayAssignmentRef}
                    userIds={selectedRowIds.value}
                />
                <StyledAssignmentHealthCarePractitioner
                    ref={hcpAssignmentRef}
                    userIds={selectedRowIds.value}
                />
            </div>
        )
    )
}

export default StyledAssignmentToolBar
